import { useState } from 'react';
import { Button, Modal, ModalProps, Stack, TextInput } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type CreateFolderModalPropsType = {
  onCreateFolder: (folderName: string) => void;
} & Omit<ModalProps, 'title'>;
export const CreateFolderModal: React.FC<CreateFolderModalPropsType> = ({
  onCreateFolder,
  ...props
}) => {
  const { t } = useTranslation();
  const [folderName, setFolderName] = useState('');

  const handleCreateFolder = () => {
    onCreateFolder(folderName);
    setFolderName('');
    props.onClose();
  };

  return (
    <Modal {...props} title={t('CREATE_FOLDER_MODAL.TITLE')}>
      <Stack>
        <TextInput
          label={t('CREATE_FOLDER_MODAL.LABELS.NAME')}
          placeholder={t('CREATE_FOLDER_MODAL.LABELS.NAME_PLACEHOLDER')}
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
        />
        <Button onClick={handleCreateFolder} disabled={!folderName}>
          {t('CREATE_FOLDER_MODAL.CONFIRM_BUTTON')}
        </Button>
      </Stack>
    </Modal>
  );
};
